import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';


export const tenantKeys = {
  all: ['tenants'],
  lists: () => [...tenantKeys.all, 'list'],
  list: (filters) => [...tenantKeys.lists(), filters],
  details: () => [...tenantKeys.all, 'detail'],
  detail: (id) => [...tenantKeys.details(), id],
};

// Fetch all tenants
export function useTenants(filters = {}, options = {}) {
  return useQuery({
    queryKey: tenantKeys.list(filters),
    queryFn: () => apiHelper.getResource('/sys/tenants/'),
    ...options,
  });
}

// Fetch single tenant
export function useTenant(id) {
  return useQuery({
    queryKey: tenantKeys.detail(id),
    queryFn: () => apiHelper.getResource(`/sys/tenants/${id}/`),
    enabled: !!id,
  });
}

// Create tenant
export function useCreateTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => apiHelper.postResource('/sys/tenants/', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantKeys.lists() });
    },
  });
}

// Update tenant
export function useUpdateTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => apiHelper.putResource(`/sys/tenants/${id}/`, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: tenantKeys.lists() });
      queryClient.invalidateQueries({ queryKey: tenantKeys.detail(id) });
    },
  });
}

// Assign tenant access to a user
// POST /api/rbac/tenant-access/
export function useAssignTenantAccess() {
  return useMutation({
    mutationFn: ({ userId, orgIds, scopes }) =>
      apiHelper.postResource('/rbac/tenant-access/', {
        user_id: userId,
        org_ids: orgIds,
        scopes,
      }),
  });
}

// Delete tenant
export function useDeleteTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => apiHelper.deleteResource(`/sys/tenants/${id}/?confirm=yes`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantKeys.lists() });
    },
  });
}
